/**
 * FeedReelSkeleton — per-reel loading placeholder for the feed. Web analogue of
 * iOS FeedVideoLoadingScreen (a spinner in the video well + a caption-card
 * skeleton). Shown while a reel's activity data is still loading or the reel is
 * not yet active, replacing the bare centered spinner so scrolling between reels
 * previews the reel's shape (video well + caption strip) instead of a black gap.
 *
 * Dark to match the feed's black video stage; uses the shared skeleton-pulse
 * keyframes (Animations.css).
 */
import { FC } from "react";

const FeedReelSkeleton: FC = () => (
  // Video-well placeholder only — soft pulsing fill + centered spinner (iOS
  // LoadingSpinner). The caption placeholder is rendered by VideoLayout in the
  // transcript strip BELOW the well, where real captions actually appear, so the
  // loading frame spans the same height as a loaded reel.
  <div className="absolute inset-0 w-full h-full bg-black overflow-hidden">
    <div className="skeleton-pulse-soft absolute inset-0 bg-white/[0.04]" />
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-white/20 border-t-white/80 rounded-full animate-spin" />
    </div>
  </div>
);

export default FeedReelSkeleton;
